'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createField = require('../createField');

var _createField2 = _interopRequireDefault(_createField);

var _immutable = require('../structure/immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createField2.default)(_immutable2.default);